import { createContext } from 'react';
import { defineAbilitiesFor } from './ability';


export const AbilityContext = createContext(defineAbilitiesFor());
